(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anbernic-collection-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('anbernic-collection-cards')) {
    customElements.define('anbernic-collection-cards', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.track = this.querySelector('.acc__track');
        this.controls = this.querySelector('.acc__controls');
        this.buttons = [...this.querySelectorAll('[data-step]')];
        if (!this.track || !this.controls) return;
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = max < 3;
          this.buttons[0].disabled = this.track.scrollLeft <= 2;
          this.buttons[1].disabled = this.track.scrollLeft > max - 3;
        };
        this.move = direction => {
          const card = this.track.querySelector('.acc__item');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
        };
        this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.step)), options));
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.dragState = { x: event.clientX, start: this.track.scrollLeft, moved: false };
          this.suppressClick = false;
        }, options);
        this.track.addEventListener('pointermove', event => {
          if (!this.dragState || (event.buttons & 1) === 0) return;
          const distance = event.clientX - this.dragState.x;
          if (!this.dragState.moved && Math.abs(distance) < 6) return;
          this.dragState.moved = true;
          this.track.classList.add('is-dragging');
          if (!this.track.hasPointerCapture(event.pointerId)) this.track.setPointerCapture(event.pointerId);
          event.preventDefault();
          this.track.scrollLeft = this.dragState.start - distance;
        }, options);
        const finishDrag = event => {
          if (!this.dragState) return;
          this.suppressClick = this.dragState.moved && event.type !== 'pointercancel';
          this.dragState = null;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          this.update();
        };
        this.track.addEventListener('pointerup', finishDrag, options);
        this.track.addEventListener('pointercancel', finishDrag, options);
        this.track.addEventListener('click', event => {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }, { ...options, capture: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const card = [...this.track.children].find(item => item.dataset.blockId === event.detail?.blockId);
          if (card) this.track.scrollTo({ left: card.offsetLeft - 4, behavior: 'auto' });
        }, options);
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.dragState = null;
        this.track?.classList.remove('is-dragging');
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anbernic-footer"] && !Shopify.designMode) return;
  try {
    
  const focusNewsletterResult = () => {
    const result = document.querySelector('.anbernic-footer__newsletter-form [data-newsletter-result]');
    if (!result) return;
    result.focus({ preventScroll: true });
    result.scrollIntoView({ behavior: 'instant', block: 'center' });
  };

  if (document.readyState === 'complete') {
    focusNewsletterResult();
  } else {
    window.addEventListener('load', focusNewsletterResult, { once: true });
  }

  document.addEventListener('invalid', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.anbernic-footer__newsletter-form input[type="email"]')) return;
    input.setCustomValidity('');
    if (input.validity.valueMissing) {
      input.setCustomValidity('Veuillez saisir votre adresse e-mail.');
    } else if (input.validity.typeMismatch) {
      input.setCustomValidity('Veuillez saisir une adresse e-mail valide.');
    }
  }, true);

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.matches('.anbernic-footer__newsletter-form input[type="email"]')) {
      input.setCustomValidity('');
    }
  });

  if (!customElements.get('anbernic-footer-accordion')) {
    customElements.define('anbernic-footer-accordion', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.anbernic-footer__toggle');
        this.panel = this.querySelector('.anbernic-footer__panel');
        if (!this.button || !this.panel || this.mediaQuery) return;
        this.expanded = false;
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.update = () => {
          const expanded = !this.mediaQuery.matches || this.expanded;
          if (!expanded && this.panel.contains(document.activeElement)) this.button.focus();
          this.panel.hidden = !expanded;
          this.button.setAttribute('aria-expanded', String(expanded));
        };
        this.toggle = () => {
          if (!this.mediaQuery.matches) return;
          this.expanded = !this.expanded;
          this.update();
        };
        this.button.addEventListener('click', this.toggle);
        this.mediaQuery.addEventListener('change', this.update);
        this.classList.add('is-enhanced');
        this.update();
      }

      disconnectedCallback() {
        if (!this.mediaQuery) return;
        this.button.removeEventListener('click', this.toggle);
        this.mediaQuery.removeEventListener('change', this.update);
        this.mediaQuery = null;
      }
    });
  }

  if (!customElements.get('anbernic-footer-localization')) {
    customElements.define('anbernic-footer-localization', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;
        this.addEventListener('change', (event) => {
          if (event.target instanceof HTMLSelectElement && event.target.form) {
            event.target.form.requestSubmit();
          }
        });
        this.setAttribute('data-enhanced', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anbernic-main-blog"]) return;
  try {
    
  if (!customElements.get('anbernic-blog')) {
    customElements.define('anbernic-blog', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.transparentHeader !== 'true') return;
        this.header = document.querySelector('.section-header');
        const main = this.closest('main');
        const section = this.closest('.shopify-section');
        if (!this.header || !main || main.querySelector('.shopify-section') !== section) return;
        this.updateHeader = () => {
          if (!this.isConnected) return;
          const height = this.header.getBoundingClientRect().height;
          this.style.setProperty('--anb-header-height', `${height}px`);
          this.dataset.transparentActive = 'true';
          this.header.classList.toggle('anb-blog-header-transparent', window.scrollY < height);
        };
        this.observer = new ResizeObserver(this.updateHeader);
        this.observer.observe(this.header);
        window.addEventListener('scroll', this.updateHeader, { passive: true });
        this.updateHeader();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.updateHeader) window.removeEventListener('scroll', this.updateHeader);
        this.header?.classList.remove('anb-blog-header-transparent');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anbernic-system-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('anbernic-system-tiles')) {
    customElements.define('anbernic-system-tiles', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.track = this.querySelector('.ast__grid');
        if (!this.track) return;
        this.mobileQuery = matchMedia('(max-width: 699px)');
        this.suppressClick = false;
        this.finishDrag = event => {
          if (!this.dragState || (event && event.pointerId !== this.dragState.pointerId)) return;
          const { pointerId, moved } = this.dragState;
          this.suppressClick = moved && event?.type === 'pointerup';
          this.dragState = null;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(pointerId)) this.track.releasePointerCapture(pointerId);
        };
        this.update = () => {
          const canScroll = this.mobileQuery.matches && this.track.scrollWidth > this.track.clientWidth + 2;
          this.track.tabIndex = canScroll ? 0 : -1;
          if (!canScroll) this.finishDrag();
        };
        this.scrollToItem = item => {
          const left = item.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
          this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.track.addEventListener('pointerdown', event => {
          this.suppressClick = false;
          if (!this.mobileQuery.matches || event.pointerType !== 'mouse' || event.button !== 0 || this.track.scrollWidth <= this.track.clientWidth + 2) return;
          this.finishDrag();
          this.dragState = { pointerId: event.pointerId, x: event.clientX, start: this.track.scrollLeft, moved: false };
        }, options);
        this.track.addEventListener('pointermove', event => {
          if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
          if ((event.buttons & 1) === 0) { this.finishDrag(event); return; }
          const distance = event.clientX - this.dragState.x;
          if (!this.dragState.moved && Math.abs(distance) < 6) return;
          this.dragState.moved = true;
          this.track.classList.add('is-dragging');
          if (!this.track.hasPointerCapture(event.pointerId)) this.track.setPointerCapture(event.pointerId);
          event.preventDefault();
          this.track.scrollLeft = this.dragState.start - distance;
        }, options);
        this.track.addEventListener('pointerup', this.finishDrag, options);
        this.track.addEventListener('pointercancel', this.finishDrag, options);
        this.track.addEventListener('lostpointercapture', this.finishDrag, options);
        this.track.addEventListener('dragstart', event => {
          if (this.mobileQuery.matches) event.preventDefault();
        }, options);
        this.track.addEventListener('click', event => {
          if (!this.suppressClick || event.detail === 0) return;
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }, { ...options, capture: true });
        this.track.addEventListener('keydown', event => {
          if (!this.mobileQuery.matches || event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const items = [...this.track.querySelectorAll('.ast__item')];
          const offset = this.track.getBoundingClientRect().left;
          const position = item => item.getBoundingClientRect().left - offset;
          let item;
          if (event.key === 'Home') item = items[0];
          else if (event.key === 'End') item = items.at(-1);
          else if (event.key === 'ArrowRight') item = items.find(candidate => position(candidate) > 2);
          else item = items.findLast(candidate => position(candidate) < -2);
          if (item) this.scrollToItem(item);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.mobileQuery.matches) return;
          const item = [...this.track.children].find(candidate => candidate.dataset.blockId === event.detail?.blockId);
          if (item) this.scrollToItem(item);
        }, options);
        this.mobileQuery.addEventListener('change', this.update, options);
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.finishDrag?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anbernic-text-with-icons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('anbernic-text-icons-v1')) {
    customElements.define('anbernic-text-icons-v1', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const start = () => { this.initFrame = requestAnimationFrame(() => this.initialize()); };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.controller.signal });
        } else {
          start();
        }
      }

      initialize() {
        if (!this.isConnected || !this.controller || this.initialized) return;
        this.track = this.querySelector('[data-ati-track]');
        this.items = Array.from(this.querySelectorAll('[data-ati-item]'));
        if (!this.track || !this.items.length) return;
        this.initialized = true;
        this.dots = Array.from(this.querySelectorAll('[data-ati-dot]'));
        this.navigation = this.querySelector('[data-ati-dots]');
        this.activeIndex = 0;
        const signal = this.controller.signal;

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateFromScroll());
        }, { passive: true, signal });

        this.addEventListener('click', (event) => {
          const dot = event.target.closest('[data-ati-dot]');
          if (dot && this.contains(dot)) this.goTo(Number(dot.dataset.atiDot));
        }, { signal });

        this.addEventListener('keydown', (event) => {
          const dot = event.target.closest('[data-ati-dot]');
          if (!this.scrollable || (event.target !== this.track && !dot) || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          const current = dot ? Number(dot.dataset.atiDot) : this.activeIndex;
          let next;
          if (event.key === 'ArrowRight') next = current + direction;
          else if (event.key === 'ArrowLeft') next = current - direction;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.items.length - 1;
          else return;
          event.preventDefault();
          next = Math.max(0, Math.min(next, this.items.length - 1));
          this.goTo(next);
          if (dot && this.dots[next]) this.dots[next].focus({ preventScroll: true });
        }, { signal });

        document.addEventListener('shopify:block:select', (event) => {
          const index = this.items.findIndex((item) => item.dataset.blockId === String(event.detail?.blockId));
          if (index >= 0) this.goTo(index, true);
        }, { signal });

        const resize = () => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.updateLayout());
        };
        window.addEventListener('resize', resize, { passive: true, signal });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(resize);
          this.observer.observe(this.track);
        }
        this.updateLayout();
      }

      updateLayout() {
        if (!this.isConnected) return;
        const overflow = getComputedStyle(this.track).overflowX;
        this.scrollable = /auto|scroll/.test(overflow) && this.track.scrollWidth > this.track.clientWidth + 2;
        this.track.tabIndex = this.scrollable ? 0 : -1;
        if (this.scrollable) this.track.setAttribute('aria-roledescription', this.dataset.carouselLabel);
        else this.track.removeAttribute('aria-roledescription');
        if (this.navigation) this.navigation.hidden = !this.scrollable;
        this.goTo(this.activeIndex, true);
      }

      goTo(index, instant = false) {
        this.activeIndex = Math.max(0, Math.min(index, this.items.length - 1));
        this.updateDots();
        if (!this.scrollable) return;
        const item = this.items[this.activeIndex].getBoundingClientRect();
        const track = this.track.getBoundingClientRect();
        const delta = item.left + item.width / 2 - (track.left + this.track.clientLeft + this.track.clientWidth / 2);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: delta, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
      }

      updateFromScroll() {
        if (!this.scrollable || !this.isConnected) return;
        const track = this.track.getBoundingClientRect();
        const center = track.left + this.track.clientLeft + this.track.clientWidth / 2;
        let nearest = Infinity;
        this.items.forEach((item, index) => {
          const box = item.getBoundingClientRect();
          const distance = Math.abs(box.left + box.width / 2 - center);
          if (distance < nearest) { nearest = distance; this.activeIndex = index; }
        });
        this.updateDots();
      }

      updateDots() {
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.activeIndex)));
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.controller = null;
        this.observer = null;
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auto-tech-specs"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'anbernic-auto-specs';
  if (customElements.get(tag)) return;
  let nextTableId = 0;

  const normalized = value => value.normalize('NFKC').trim().toLocaleLowerCase()
    .replace(/[：:]\s*$/, '').replace(/\s+/g, ' ');
  const names = new Set([
    'color', 'colour', 'colors', 'screen', 'display', 'cpu', 'processor', 'gpu', 'ram',
    'memory', 'storage', 'system', 'os', 'operating system', 'games', 'language',
    'speaker', 'speakers', 'audio', 'battery', 'tf card', 'sd card', 'connectivity',
    'wi-fi', 'wifi', 'bluetooth', 'other functions', 'accessories', 'appearance',
    'box specification', 'console specification', 'dimensions', 'weight', 'ports',
    'couleur', 'couleurs', 'écran', 'processeur', 'mémoire', 'mémoire vive', 'stockage',
    'système', "système d’exploitation", "système d'exploitation", 'jeux', 'langue',
    'langues', 'haut-parleur', 'haut-parleurs', 'batterie', 'carte tf', 'carte sd',
    'autres fonctions', 'accessoires', 'poids', 'dimensions de la boîte',
    'farbe', 'bildschirm', 'prozessor', 'arbeitsspeicher', 'speicher', 'betriebssystem',
    'spiele', 'sprache', 'lautsprecher', 'akku', 'zubehör', 'abmessungen', 'gewicht',
    'cor', 'cores', 'tela', 'processador', 'memória', 'armazenamento', 'sistema',
    'jogos', 'idioma', 'alto-falante', 'bateria', 'acessórios', 'dimensões', 'peso',
    '颜色', '顏色', '屏幕', '螢幕', '处理器', '處理器', '内存', '記憶體', '存储', '儲存',
    '系统', '系統', '游戏', '遊戲', '语言', '語言', '扬声器', '电池', '電池', '其他功能',
    '配件', '尺寸', '重量', '外观', '包装规格', '主机规格',
    'カラー', '色', '画面', 'スクリーン', 'ディスプレイ', 'プロセッサー', 'メモリ',
    'ストレージ', 'システム', 'ゲーム', '言語', 'スピーカー', 'バッテリー',
    'その他の機能', '付属品', 'サイズ', '本体サイズ', '重さ'
  ]);
  const known = label => names.has(normalized(label));
  const richOrInteractive = 'img, picture, video, audio, iframe, svg, canvas, form, input, button, script, style, object, embed, details';
  const specHeading = /sp[eé]cification|technical|caractéristiques|fiche technique|technische|especificaç|技术参数|技術仕様|製品仕様/i;
  const dimensionValue = /^(length|width|height|weight|longueur|largeur|hauteur|poids|länge|breite|höhe|gewicht|comprimento|largura|altura|peso|长|長|宽|寬|高|重量|幅|高さ|奥行|重さ)\s*[:：]?\s*\d/i;
  const configurationLabels = new Set([
    'mémoire et stockage', 'mémoire/stockage', 'memory and storage', 'memory & storage',
    'ram/rom', 'ram+rom', 'ram & rom', 'ram and storage', 'ram + storage',
    'memória e armazenamento', 'arbeitsspeicher und speicher', 'ram und speicher',
    '内存和存储', '内存/存储', '内存及存储', '記憶體與儲存', 'メモリとストレージ', 'メモリ/ストレージ'
  ]);
  const colorLabels = new Set(['color', 'colour', 'colors', 'couleur', 'couleurs', 'farbe', 'cor', 'cores', '颜色', '顏色', 'カラー', '色']);
  const matrixLabels = new Set(['model', 'modèle', 'modele', 'modelo', 'modell', '型号', '型號', '機種', 'モデル', 'parameter', 'paramètre', '参数', ...colorLabels]);
  const capacityPair = /^\d+(?:[.,]\d+)?\s*(?:[GMT](?:B|O)?|GiB|TiB)\s*[+／/]\s*\d+(?:[.,]\d+)?\s*(?:[GMT](?:B|O)?|GiB|TiB)$/i;

  function logicalRows(table) {
    const sourceRows = [...table.rows];
    const records = [];
    let active = [];
    let rowGroup = null;
    let spanWidth = null;
    for (const row of sourceRows) {
      if (row.parentElement !== rowGroup) {
        active = [];
        spanWidth = null;
        rowGroup = row.parentElement;
      }
      const inherited = active.some(slot => slot?.remaining > 0);
      const grid = active.map(slot => slot?.remaining > 0 ? slot.cell : null);
      for (const slot of active) if (slot?.remaining > 0) slot.remaining--;
      let column = 0;
      for (const cell of row.cells) {
        while (grid[column]) column++;
        const width = cell.colSpan;
        if (column + width > 20) return null;
        const remainingGroupRows = [...rowGroup.rows].length - [...rowGroup.rows].indexOf(row);
        const height = cell.rowSpan === 0 ? remainingGroupRows : Math.min(cell.rowSpan, remainingGroupRows);
        for (let offset = 0; offset < width; offset++) {
          if (grid[column + offset]) return null;
          grid[column + offset] = cell;
          active[column + offset] = {cell, remaining: height - 1};
        }
        column += width;
      }
      while (grid.length && !grid[grid.length - 1]) grid.pop();
      if (!grid.length) continue;
      if (grid.some(cell => !cell)) return null;
      if (inherited && grid.length !== spanWidth) return null;
      spanWidth = active.some(slot => slot?.remaining > 0) ? grid.length : null;
      if (!row.cells.length && inherited) continue;
      const cells = [...new Set(grid)];
      const previous = records[records.length - 1];
      if (previous && previous.cells[0] === cells[0] && cells.length > 1) {
        const freshValues = cells.slice(1).filter(cell => [...row.cells].includes(cell));
        if (freshValues.length) {
          previous.valueGroups.push(cells.slice(1));
          previous.grids.push(grid);
        }
      } else {
        records.push({node: row, cells, grids: [grid], valueGroups: cells.length > 1 ? [cells.slice(1)] : []});
      }
    }
    return records;
  }

  function canCombineValues(row) {
    const label = normalized(row.cells[0].textContent);
    return row.valueGroups.every(group => {
      if (group.length <= 1) return true;
      if (group.some(cell => cell.tagName === 'TH')) return false;
      const values = group.map(cell => normalized(cell.textContent));
      if (values.every(value => dimensionValue.test(value))) return true;
      if (configurationLabels.has(label) && values.every(value => capacityPair.test(value))) return true;
      return colorLabels.has(label) && values.every(value => value.length > 0 && value.length <= 120);
    });
  }

  function measureKind(cell) {
    const value = normalized(cell.textContent);
    if (!/\d/.test(value)) return '';
    return /^(dimensions?|size|尺寸)/i.test(value) ? 'dimensions'
      : /^(poids|weight|gewicht|peso|重量|重さ)/i.test(value) ? 'weight'
      : dimensionValue.test(value) ? value.split(/[\s:：\d]/)[0] : '';
  }

  function matrixData(rows) {
    const header = rows.find(row => row.cells.length >= 2);
    if (!header || !matrixLabels.has(normalized(header.cells[0].textContent))) return null;
    const grid = header.grids[0];
    const columns = [];
    const seen = new Set([header.cells[0]]);
    grid.forEach((cell, start) => {
      if (!seen.has(cell) && cell.textContent.trim()) {
        columns.push({cell, start, end: grid.length});
        seen.add(cell);
      }
    });
    if (columns.length < 2 || columns.length > 4) return null;
    columns.forEach((column, index) => { column.end = columns[index + 1]?.start ?? grid.length; });
    if (rows.some(row => row.cells.length > 1 && row.grids.some(rowGrid => rowGrid.length !== grid.length))) return null;
    return {header, columns};
  }

  function cleanClone(node) {
    const copy = node.cloneNode(true);
    if (copy.nodeType === Node.ELEMENT_NODE) {
      for (const el of [copy, ...copy.querySelectorAll('*')]) {
        for (const attr of [...el.attributes]) {
          if (attr.name.startsWith('on') || ['style', 'class', 'id', 'align', 'valign', 'bgcolor'].includes(attr.name) || (['width', 'height'].includes(attr.name) && el.tagName !== 'IMG')) {
            el.removeAttribute(attr.name);
          }
        }
      }
      const nestedTables = [copy, ...copy.querySelectorAll('table')].filter(el => el.tagName === 'TABLE').reverse();
      for (const table of nestedTables) {
        if (table.rows.length === 1 && table.rows[0].cells.length === 1) {
          const fragment = document.createDocumentFragment();
          fragment.append(...table.rows[0].cells[0].childNodes);
          if (table === copy) return fragment;
          table.replaceWith(fragment);
        }
      }
    }
    return copy;
  }

  function appendContents(target, original) {
    for (const child of original.childNodes) target.append(cleanClone(child));
  }

  function plainLines(element) {
    const copy = element.cloneNode(true);
    copy.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
    return copy.textContent.split(/\n/).map(line => line.trim()).filter(Boolean);
  }

  function linePair(line) {
    const match = line.match(/^([^:：\n]{1,64})\s*[:：]\s*(.+)$/u);
    if (!match || /https?|mailto/i.test(match[1])) return null;
    return { label: match[1].trim(), value: match[2].trim() };
  }

  const legacyPrefix = /^(?:[-‐‑‒–—−]+|[•●▪◦*])\s*/u;
  const legacyNames = new Set([
    'wifi/bluetooth', 'wi-fi/bluetooth', 'fonction', 'multimédia réseau', 'network multimedia',
    'matériau', 'material', 'jeu', 'charge', 'charging', 'dissipation de puissance', 'power dissipation', 'apparence'
  ]);
  const legacyKnown = label => known(label) || legacyNames.has(normalized(label));
  const legacyFunctions = new Set(['autres fonctions', 'other functions']);
  const legacyEmulatorNote = text =>
    /^(?:prise en charge|prend en charge|supports?)\b/i.test(text)
    && /\d/.test(text) && /[ée]mulateurs?|emulators?/i.test(text);
  const legacyHeading = text => specHeading.test(text) || /^description de la RG\d+[a-z0-9]*$/i.test(text);
  const legacyNoteContinuation = (entry, text) => entry?.kind === 'note'
    && !entry.continuations.length && legacyEmulatorNote(entry.text)
    && /^Permet aux utilisateurs de télécharger des jeux dans les formats correspondants[.!]?$/i.test(text);
  const legacyContinuation = (entry, text) => entry?.kind === 'pair'
    && legacyFunctions.has(normalized(entry.label))
    && !entry.continuations.length && /[\/／]\s*$/.test(entry.value)
    && /^(?:r[eé]glages?\b|power[- ]saving\b|energy[- ]saving\b|screen brightness\b)/i.test(text);

  function nextPlainSibling(node) {
    const sibling = node.nextElementSibling;
    for (let between = node.nextSibling; between && between !== sibling; between = between.nextSibling) {
      if (between.nodeType === Node.TEXT_NODE && between.textContent.trim()) return null;
    }
    return sibling;
  }

  function previousPlainSibling(node) {
    const sibling = node.previousElementSibling;
    for (let between = node.previousSibling; between && between !== sibling; between = between.previousSibling) {
      if (between.nodeType === Node.TEXT_NODE && between.textContent.trim()) return null;
    }
    return sibling;
  }

  function tableData(table) {
    if (table.id || table.querySelector('[id], video, audio, iframe, svg, canvas, form, input, button, script, style, object, embed, details')) return null;
    if ([...table.querySelectorAll('table')].some(nested => nested.rows.length !== 1 || nested.rows[0].cells.length !== 1)) return null;
    const rows = logicalRows(table);
    if (!rows || rows.length < 2) return null;
    const matrix = matrixData(rows);
    if (!matrix && rows.some(row => !canCombineValues(row))) return null;
    const pairs = rows.filter(row => row.cells.length >= 2);
    if (pairs.some(row => !row.cells[0].textContent.trim() || row.cells[0].textContent.trim().length > 90)) return null;
    if (pairs.length < 2) return null;
    if (table.caption?.querySelector('a')) return null;
    const titleRow = !table.caption && rows[0].cells.length === 1 && !rows[0].node.querySelector('a') ? rows[0] : null;
    const heading = table.caption?.textContent || titleRow?.cells[0].textContent || '';
    const matchCount = pairs.filter(row => known(row.cells[0].textContent)).length;
    if (matchCount < 2 && !(matchCount >= 1 && specHeading.test(heading))) return null;
    return { rows, heading, titleRow, matrix };
  }

  class AutoSpecs extends HTMLElement {
    static get observedAttributes() {
      return ['data-spec-profile', 'data-mobile-collapse', 'data-mobile-limit', 'data-expand-label', 'data-collapse-label', 'data-design', 'data-show-highlights', 'data-default-tab', 'data-overview-label', 'data-details-label'];
    }

    attributeChangedCallback(name) {
      if (!this.isConnected) return;
      if (name === 'data-default-tab') this.querySelectorAll('.as-card').forEach(card => { card._asActiveTab = null; card._asPresentationSignature = null; });
      if (['data-spec-profile', 'data-design', 'data-show-highlights', 'data-default-tab', 'data-overview-label', 'data-details-label'].includes(name)) this.enhance();
      else this.syncCollapse();
    }

    connectedCallback() {
      this.mobileQuery ||= window.matchMedia('(max-width: 749px)');
      this.onViewportChange ||= () => {
        this.querySelectorAll('.as-table-wrap').forEach(wrap => wrap.getAnimations().forEach(animation => animation.cancel()));
        this.syncCollapse();
      };
      this.mobileQuery.addEventListener('change', this.onViewportChange);
      this.observer ||= new MutationObserver(() => {
        if (this.queued) return;
        this.queued = true;
        queueMicrotask(() => {
          this.queued = false;
          if (this.isConnected) this.enhance();
        });
      });
      this.enhance();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobileQuery?.removeEventListener('change', this.onViewportChange);
      this.querySelectorAll('.as-table-wrap').forEach(wrap => wrap.getAnimations().forEach(animation => animation.cancel()));
    }

    syncCollapse() {
      const enabled = this.dataset.mobileCollapse !== 'false';
      const requested = Number.parseInt(this.dataset.mobileLimit || '10', 10);
      const limit = Number.isFinite(requested) ? Math.max(1, requested) : 10;
      const mobile = this.mobileQuery?.matches ?? window.matchMedia('(max-width: 749px)').matches;
      for (const card of this.querySelectorAll('.as-card')) {
        const table = card.querySelector('.as-table');
        if (!table) continue;
        const rows = [...table.rows];
        const parameters = rows.filter(row => row.querySelector('th[scope="row"]'));
        const hasMore = parameters.length > limit;
        let button = card.querySelector('.as-toggle');
        if (hasMore && enabled && !button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'as-toggle';
          const label = document.createElement('span');
          label.className = 'as-toggle-label';
          const arrow = document.createElement('span');
          arrow.className = 'as-toggle-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          button.append(label, arrow);
          if (!table.id) {
            do { table.id = `as-spec-table-${++nextTableId}`; }
            while (document.getElementById(table.id) && document.getElementById(table.id) !== table);
          }
          button.setAttribute('aria-controls', table.id);
          button.addEventListener('click', () => {
            const expanded = card.dataset.mobileExpanded === 'true';
            const wrap = card.querySelector('.as-table-wrap');
            const previousHeight = wrap.getBoundingClientRect().height;
            const hiddenRows = [...table.rows].filter(row => row.hidden);
            wrap.getAnimations().forEach(animation => animation.cancel());
            [...table.rows].forEach(row => row.getAnimations().forEach(animation => animation.cancel()));
            card.dataset.mobileExpanded = String(!expanded);
            this.syncCollapse();
            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              wrap.animate([
                {height: `${previousHeight}px`},
                {height: `${wrap.getBoundingClientRect().height}px`}
              ], {duration: 280, easing: 'cubic-bezier(.22, .68, 0, 1)'});
              if (!expanded) hiddenRows.forEach((row, index) => row.animate([
                {opacity: 0}, {opacity: 1}
              ], {duration: 220, delay: Math.min(index, 6) * 18, fill: 'backwards', easing: 'ease-out'}));
            }
            if (expanded) requestAnimationFrame(() => {
              const rect = button.getBoundingClientRect();
              if (rect.top < 0 || rect.bottom > window.innerHeight) button.scrollIntoView({block: 'nearest'});
            });
          });
          card.append(button);
        }
        const active = enabled && mobile && hasMore;
        const collapsed = active && card.dataset.mobileExpanded !== 'true';
        const boundary = hasMore ? rows.indexOf(parameters[limit - 1]) : rows.length;
        rows.forEach((row, index) => { row.hidden = collapsed && index > boundary; });
        if (button) {
          button.hidden = !active || card.dataset.activeTab === 'overview';
          button.setAttribute('aria-expanded', String(!collapsed));
          const label = collapsed
            ? this.dataset.expandLabel || 'Afficher tous les paramètres'
            : this.dataset.collapseLabel || 'Réduire';
          const text = button.querySelector('.as-toggle-label');
          if (text.textContent !== label) text.textContent = label;
        }
      }
    }

    controllerKind(label) {
      const key = normalized(label).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/’/g, "'");
      if (['plateformes', 'plateformes compatibles', 'platforms'].includes(key)) return 'platforms';
      if (['methodes de connexion', 'connexion', 'connection methods'].includes(key)) return 'connection';
      if (/^(type de joysticks?|joysticks?|joystick type)$/.test(key)) return 'joysticks';
      if (['type de gachettes', 'gachettes', 'trigger type'].includes(key)) return 'triggers';
      if (['taux de rapport', 'polling rate'].includes(key)) return 'polling';
      if (['batterie', 'battery'].includes(key)) return 'battery';
      if (['bouton supplementaire', 'boutons supplementaires', 'additional buttons'].includes(key)) return 'extras';
      if (['ecran', 'screen'].includes(key)) return 'screen';
      if (['vibration'].includes(key)) return 'vibration';
      if (['disposition des boutons', 'button layout'].includes(key)) return 'layout';
      return '';
    }

    highlightKind(label) {
      const key = normalized(label);
      if (['screen','display','écran','bildschirm','tela','屏幕','螢幕','画面','スクリーン','ディスプレイ'].includes(key)) return 'screen';
      if (['cpu','processor','processeur','prozessor','processador','处理器','處理器','プロセッサー'].includes(key)) return 'cpu';
      if (configurationLabels.has(key) || ['mémoire & stockage','memory','ram','mémoire','mémoire vive','stockage','storage','memória','arbeitsspeicher','speicher','armazenamento','内存','記憶體','存储','儲存','メモリ','ストレージ'].includes(key)) return 'memory';
      if (['battery','batterie','akku','bateria','电池','電池','バッテリー'].includes(key)) return 'battery';
      return '';
    }

    summaryFor(row, kind) {
      const label = row.cells[0].textContent.trim();
      const parts = [...row.cells[1].querySelectorAll('.as-value-part')];
      const values = (parts.length ? parts : [row.cells[1]]).map(node => node.textContent.trim()).filter(Boolean);
      let summary = values;
      let sub = '';
      if (values.length === 1) {
        const raw = values[0];
        if (this.dataset.specProfile === 'controller' && ['platforms', 'connection'].includes(kind)) {
          summary = [raw.split('/').map(part => part.trim()).join(' / ')];
        }
        if (this.dataset.specProfile === 'controller' && ['joysticks', 'triggers'].includes(kind)) {
          // The overview quotes the first source clause; the complete value stays in the details table.
          const clauses = raw.split(/,\s*/);
          summary = [clauses[0]];
          if (kind === 'triggers' && clauses.length > 1) sub = clauses.slice(1).join(', ');
        }
        if (kind === 'screen') {
          const sizes = [...raw.matchAll(/\d+(?:[.,]\d+)?(?:\s*-\s*|\s*)(?:inch(?:es)?|pouces?|Zoll|polegadas?|pulgadas?|英寸|インチ)/gi)];
          if (sizes.length === 1) {
            summary = [sizes[0][0]];
            const resolution = raw.match(/\d{3,4}\s*[×x*]\s*\d{3,4}/i);
            sub = resolution?.[0] || '';
          }
        } else if (kind === 'cpu') {
          const snapdragon = raw.match(/Snapdragon\s+([^()，,;；]+?)(?=\s*\(|\s*（|$)/i);
          const chip = raw.match(/\b(?:RK\d{4}[A-Z0-9]*|H\d{3}[A-Z0-9]*|T\d{3}[A-Z0-9]*|Dimensity\s+\d+|Helio\s+G\d+)\b/i);
          if (snapdragon) {
            summary = [snapdragon[1].trim()];
            sub = raw.match(/(?:Qualcomm\s+)?Snapdragon/i)?.[0] || '';
          } else if (chip) summary = [chip[0]];
        } else if (kind === 'battery') {
          const capacities = [...raw.matchAll(/\d+(?:[.,]\d+)?\s*mAh\b/gi)];
          if (capacities.length === 1) {
            summary = [capacities[0][0]];
            sub = raw.match(/(?:autonomie[^,;.]{0,60}?heures?|lasting[^,;.]{0,50}?hours?|up to\s+\d+(?:[.,]\d+)?\s*hours?)/i)?.[0] || '';
          }
        }
      }
      return {label, values: summary, sub, kind};
    }

    buildHighlight(summary) {
      const tile = document.createElement('div');
      tile.className = 'as-highlight';
      tile.dataset.kind = summary.kind;
      const head = document.createElement('div');
      head.className = 'as-highlight-head';
      const label = document.createElement('span');
      label.textContent = summary.label;
      const icon = document.createElement('span');
      icon.className = `as-highlight-icon as-highlight-icon--${summary.kind}`;
      icon.setAttribute('aria-hidden','true');
      head.append(label,icon);
      const value = document.createElement('div');
      value.className = 'as-highlight-value';
      value.classList.toggle('as-highlight-value--long', summary.values.some(text => text.length > 22));
      summary.values.forEach(text => {
        const part = document.createElement('div');
        part.textContent = text;
        value.append(part);
      });
      tile.append(head,value);
      if (summary.sub) {
        const sub = document.createElement('div');
        sub.className = 'as-highlight-sub';
        sub.textContent = summary.sub;
        tile.append(sub);
      }
      return tile;
    }

    syncPresentation() {
      const design = ['dossier','manual','pixel'].includes(this.dataset.design) ? this.dataset.design : 'classic';
      for (const card of this.querySelectorAll('.as-card')) {
        card.dataset.design = design;
        const controller = this.dataset.specProfile === 'controller';
        card.dataset.specProfile = controller ? 'controller' : 'auto';
        const table = card.querySelector('.as-table');
        const wrap = card.querySelector('.as-table-wrap');
        const rows = [...table.rows].filter(row => row.querySelector('th[scope="row"]'));
        const overviewLabel = this.dataset.overviewLabel?.trim() || 'L’essentiel';
        const detailsLabel = this.dataset.detailsLabel?.trim() || 'Tous les paramètres';
        const signature = [design,this.dataset.specProfile,this.dataset.showHighlights,this.dataset.defaultTab,overviewLabel,detailsLabel,table.textContent].join('\u001f');
        if (card._asPresentationSignature === signature) continue;
        card._asPresentationSignature = signature;
        card.querySelector('.as-view-tabs')?.remove();
        card.querySelector('.as-overview')?.remove();
        wrap.hidden = false;
        if (wrap.getAttribute('role') === 'tabpanel') {
          wrap.removeAttribute('role');
          wrap.removeAttribute('aria-labelledby');
        }
        delete card.dataset.activeTab;
        const collapse = card.querySelector('.as-toggle');
        if (collapse) collapse.hidden = true;
        if (design === 'classic' || this.dataset.showHighlights === 'false' || table.classList.contains('as-table--matrix')) continue;
        const eligible = rows.filter(row => row.cells.length === 2 && !row.cells[1].querySelector('img, picture, table, a') && row.cells[1].textContent.trim());
        const chosen = [];
        const priority = controller ? ['platforms','connection','joysticks','triggers'] : ['screen','cpu','memory','battery'];
        for (const kind of priority) {
          const candidates = eligible.filter(row => (controller ? this.controllerKind(row.cells[0].textContent) : this.highlightKind(row.cells[0].textContent)) === kind);
          const combined = candidates.find(row => configurationLabels.has(normalized(row.cells[0].textContent)) || normalized(row.cells[0].textContent) === 'mémoire & stockage');
          const ram = candidates.find(row => normalized(row.cells[0].textContent) === 'ram');
          const row = combined || ram || candidates[0];
          if (row) chosen.push({row, summary:this.summaryFor(row,kind)});
        }
        if (chosen.length < 2) continue;
        if (!table.id) {
          do { table.id = `as-spec-table-${++nextTableId}`; }
          while (document.getElementById(table.id) && document.getElementById(table.id) !== table);
        }
        const overview = document.createElement('div');
        overview.className = 'as-overview';
        overview.id = `${table.id}-overview`;
        overview.setAttribute('role','tabpanel');
        const highlights = document.createElement('div');
        highlights.className = 'as-highlights';
        highlights.dataset.count = String(chosen.length);
        highlights.style.setProperty('--as-highlight-columns',String(chosen.length));
        chosen.forEach(item => highlights.append(this.buildHighlight(item.summary)));
        overview.append(highlights);
        const used = new Set(chosen.map(item => item.row));
        const remaining = eligible.filter(row => !used.has(row) && row.cells[1].textContent.trim().length <= 160);
        const basics = controller
          ? ['polling','battery','extras','screen','vibration','layout']
              .map(kind => remaining.find(row => this.controllerKind(row.cells[0].textContent) === kind))
              .filter(Boolean).slice(0,4)
          : remaining.slice(0,4);
        if (basics.length) {
          const list = document.createElement('dl');
          list.className = 'as-overview-list';
          basics.forEach(row => {
            const item = document.createElement('div');
            const name = document.createElement('dt');
            name.textContent = row.cells[0].textContent.trim();
            name.dataset.parameterIndex = String(rows.indexOf(row) + 1).padStart(2,'0');
            const value = document.createElement('dd');
            const parts = [...row.cells[1].querySelectorAll('.as-value-part')];
            value.textContent = (parts.length ? parts : [row.cells[1]]).map(node => node.textContent.trim()).join(' · ');
            item.append(name,value);
            list.append(item);
          });
          overview.append(list);
        }
        const nav = document.createElement('div');
        nav.className = 'as-view-tabs';
        nav.setAttribute('role','tablist');
        nav.setAttribute('aria-label',card.querySelector('.as-title')?.textContent || detailsLabel);
        const tabs = [overviewLabel,detailsLabel].map((label,index) => {
          const tab = document.createElement('button');
          tab.type = 'button';
          tab.setAttribute('role','tab');
          tab.id = `${table.id}-tab-${index}`;
          tab.textContent = label;
          nav.append(tab);
          return tab;
        });
        wrap.id = `${table.id}-details`;
        wrap.setAttribute('role','tabpanel');
        overview.setAttribute('aria-labelledby',tabs[0].id);
        wrap.setAttribute('aria-labelledby',tabs[1].id);
        tabs[0].setAttribute('aria-controls',overview.id);
        tabs[1].setAttribute('aria-controls',wrap.id);
        const activate = index => {
          card.dataset.activeTab = index === 0 ? 'overview' : 'details';
          card._asActiveTab = card.dataset.activeTab;
          overview.hidden = index !== 0;
          wrap.hidden = index !== 1;
          tabs.forEach((tab,position) => {
            tab.setAttribute('aria-selected',String(position === index));
            tab.tabIndex = position === index ? 0 : -1;
          });
          this.syncCollapse();
        };
        tabs.forEach((tab,index) => {
          tab.addEventListener('click',() => activate(index));
          tab.addEventListener('keydown',event => {
            if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - index;
            activate(next);
            tabs[next].focus();
          });
        });
        wrap.before(nav,overview);
        activate((card._asActiveTab || this.dataset.defaultTab || 'overview') === 'details' ? 1 : 0);
      }
    }

    findLeadingTitle(source) {
      let node = source.firstElementChild;
      while (node?.matches('div, section') && !node.matches('.as-card') && node.firstElementChild) node = node.firstElementChild;
      if (!node || node.closest('.as-card') || !node.matches('p, h1, h2, h3, h4, h5, h6')) return null;
      if (node.querySelector(`a, ${richOrInteractive}`)) return null;
      if (node.matches('p') && !node.querySelector('strong, b') && !specHeading.test(node.textContent)) return null;
      const lines = plainLines(node);
      if (lines.length !== 1 || lines[0].length > 240 || linePair(lines[0])) return null;
      return {node, text: node.textContent.trim(), used: false};
    }

    card(originalHeading = '', matrix = null) {
      const card = document.createElement('section');
      card.className = 'as-card';
      const title = this.dataset.heading || originalHeading;
      if (title) {
        const header = document.createElement('header');
        header.className = 'as-header';
        const heading = document.createElement('h2');
        heading.className = 'as-title';
        heading.textContent = title;
        header.append(heading);
        card.append(header);
      }
      const table = document.createElement('table');
      table.className = 'as-table';
      const caption = document.createElement('caption');
      caption.className = 'as-sr-only';
      caption.textContent = originalHeading || title;
      const columns = document.createElement('colgroup');
      const labelColumn = document.createElement('col');
      labelColumn.className = 'as-label-column';
      columns.append(labelColumn);
      for (let i = 0; i < (matrix?.columns.length || 1); i++) columns.append(document.createElement('col'));
      table.append(caption, columns, document.createElement('tbody'));
      const wrap = document.createElement('div');
      wrap.className = 'as-table-wrap';
      if (matrix) {
        table.classList.add('as-table--matrix');
        wrap.classList.add('as-table-wrap--matrix');
        wrap.tabIndex = 0;
        wrap.setAttribute('role', 'region');
        if (title) wrap.setAttribute('aria-label', title);
      }
      wrap.append(table);
      card.append(wrap);
      return { card, body: table.tBodies[0] };
    }

    transformTable(table, data, leadingTitle) {
      const leading = leadingTitle && !leadingTitle.used ? leadingTitle : null;
      const { card, body } = this.card(leading?.text || data.heading.trim(), data.matrix);
      if (leading && table.caption && data.heading.trim() !== leading.text) {
        const note = body.insertRow().insertCell();
        note.colSpan = 1 + (data.matrix?.columns.length || 1);
        note.className = 'as-note';
        appendContents(note, table.caption);
      }
      let count = 0;
      data.rows.forEach((row, index) => {
        const cells = [...row.cells];
        if (!cells.length) return;
        if (row === data.titleRow && (!leading || leading.text === data.heading.trim())) return;
        const output = document.createElement('tr');
        if (row === data.matrix?.header) {
          output.className = 'as-matrix-heading';
          for (const source of [cells[0], ...data.matrix.columns.map(column => column.cell)]) {
            const cell = document.createElement('th');
            cell.scope = 'col';
            appendContents(cell, source);
            output.append(cell);
          }
          body.append(output);
          return;
        }
        if (cells.length === 1) {
          const cell = document.createElement('td');
          cell.colSpan = 1 + (data.matrix?.columns.length || 1);
          cell.className = 'as-note';
          appendContents(cell, cells[0]);
          output.append(cell);
        } else {
          const label = document.createElement('th');
          label.scope = 'row';
          appendContents(label, cells[0]);
          output.append(label);
          let groups = [{valueGroups: row.valueGroups, span: data.matrix?.columns.length || 1}];
          if (data.matrix) {
            const kinds = row.valueGroups.flat().map(measureKind);
            const independentMeasures = colorLabels.has(normalized(data.matrix.header.cells[0].textContent)) && kinds.length > 1 && kinds.every(Boolean) && new Set(kinds).size === kinds.length && row.valueGroups.flat().some(cell => data.matrix.columns.every(column => normalized(cell.textContent).includes(normalized(column.cell.textContent))));
            const columns = data.matrix.columns.map(column => ({
              valueGroups: row.grids.map(grid => [...new Set(grid.slice(column.start, column.end))]), span: 1
            }));
            const shared = columns.every(column => column.valueGroups.every((values, index) => values.length === columns[0].valueGroups[index].length && values.every((cell, pos) => cell === columns[0].valueGroups[index][pos])));
            if (!shared && !independentMeasures) groups = columns;
          }
          groups.forEach(group => {
            const value = document.createElement('td');
            value.colSpan = group.span;
            group.valueGroups.forEach(cells => {
              const valueGroup = document.createElement('div');
              valueGroup.className = 'as-value-group';
              cells.forEach(cell => {
                const part = document.createElement('div');
                part.className = 'as-value-part';
                appendContents(part, cell);
                valueGroup.append(part);
              });
              value.append(valueGroup);
            });
            output.append(value);
          });
          count++;
        }
        body.append(output);
      });
      card.dataset.rows = String(count);
      table.replaceWith(card);
      if (leading) { leading.node.remove(); leading.used = true; }
    }

    transformLegacyLines(source, leadingTitle) {
      const candidates = new Set([...source.querySelectorAll('p, li, div')].filter(node =>
        !node.id && !node.closest('table, .as-card') && !node.querySelector(`[id], p, li, div, ul, ol, table, h1, h2, h3, h4, h5, h6, a, ${richOrInteractive}`)
      ));
      for (const first of candidates) {
        if (!first.isConnected) continue;
        const firstLine = plainLines(first)[0] || '';
        if (!legacyPrefix.test(firstLine) || !linePair(firstLine.replace(legacyPrefix, ''))) continue;
        const headingSpacers = [];
        let headingNode = previousPlainSibling(first);
        while (headingNode && candidates.has(headingNode) && !plainLines(headingNode).length) {
          headingSpacers.push(headingNode);
          headingNode = previousPlainSibling(headingNode);
        }
        const headingLines = headingNode ? plainLines(headingNode) : [];
        const hasHeading = headingNode?.matches('p, div, h1, h2, h3, h4, h5, h6')
          && !headingNode.id
          && !headingNode.querySelector(`[id], p, li, div, ul, ol, table, h1, h2, h3, h4, h5, h6, a, ${richOrInteractive}`)
          && headingLines.length === 1 && headingLines[0].length <= 240
          && legacyHeading(headingLines[0]) && !linePair(headingLines[0]);
        const leading = hasHeading ? (headingNode === leadingTitle?.node
          ? leadingTitle : {node: headingNode, text: headingNode.textContent.trim(), used: false}) : null;
        // Asterisks also mark editorial notices; require an explicit adjacent spec heading.
        if (/^\*/.test(firstLine) && !leading) continue;
        const run = [];
        let entries = [];
        let current = first;
        while (current && candidates.has(current)) {
          const lines = plainLines(current);
          if (!lines.length) {
            run.push(current);
            current = nextPlainSibling(current);
            continue;
          }
          // Plan the whole element before consuming it, including any <br> lines.
          const trial = entries.map(entry => ({...entry, continuations: [...(entry.continuations || [])]}));
          let accepted = lines.length > 0;
          for (const line of lines) {
            if (/^\*/.test(line) && !leading) { accepted = false; break; }
            const prefixed = legacyPrefix.test(line);
            const text = prefixed ? line.replace(legacyPrefix, '') : line;
            const pair = prefixed ? linePair(text) : null;
            if (pair && legacyKnown(pair.label)) {
              trial.push({...pair, kind: 'pair', continuations: []});
            } else if (leading && trial.filter(entry => entry.kind === 'pair' && legacyKnown(entry.label)).length >= 2
              && prefixed && legacyEmulatorNote(text)) {
              // A legacy feature sentence has no label; keep it as a full-width note.
              trial.push({kind: 'note', text, continuations: []});
            } else if (leading && ((!prefixed && legacyNoteContinuation(trial[trial.length - 1], text))
              || legacyContinuation(trial[trial.length - 1], text))) {
              trial[trial.length - 1].continuations.push(text);
            } else {
              accepted = false;
              break;
            }
          }
          if (!accepted) break;
          entries = trial;
          run.push(current);
          current = nextPlainSibling(current);
        }
        const pairs = entries.filter(entry => entry.kind === 'pair');
        if (pairs.filter(pair => legacyKnown(pair.label)).length < 2) continue;
        const {card, body} = this.card(leading?.text || '');
        for (const entry of entries) {
          const row = document.createElement('tr');
          if (entry.kind === 'note') {
            const note = document.createElement('td');
            note.colSpan = 2;
            note.className = 'as-note';
            note.textContent = entry.text;
            for (const continuation of entry.continuations) {
              note.append(document.createElement('br'), document.createTextNode(`\n${continuation}`));
            }
            row.append(note);
          } else {
            const label = document.createElement('th');
            label.scope = 'row';
            label.textContent = entry.label;
            const value = document.createElement('td');
            value.textContent = entry.value;
            for (const continuation of entry.continuations) {
              value.append(document.createElement('br'), document.createTextNode(`\n${continuation}`));
            }
            row.append(label, value);
          }
          body.append(row);
        }
        card.dataset.rows = String(pairs.length);
        if (first.tagName === 'LI') {
          const item = document.createElement('li');
          item.className = 'as-list-card';
          item.append(card);
          first.before(item);
        } else first.before(card);
        run.forEach(node => node.remove());
        if (leading) {
          leading.node.remove();
          headingSpacers.forEach(node => node.remove());
          leading.used = true;
        }
      }
    }

    transformLines(source, leadingTitle) {
      this.transformLegacyLines(source, leadingTitle);
      const candidates = [...source.querySelectorAll('p, li, div')].filter(node =>
        !node.id && !node.closest('table, .as-card') && !node.querySelector(`[id], p, li, div, ul, ol, table, h1, h2, h3, h4, h5, h6, a, ${richOrInteractive}`)
      );
      const processed = new Set();
      for (const first of candidates) {
        if (processed.has(first) || !first.isConnected) continue;
        const run = [];
        let current = first;
        while (current && candidates.includes(current) && !processed.has(current)) {
          const lines = plainLines(current);
          const pairs = lines.map(linePair);
          if (!pairs.length || pairs.some(pair => !pair)) break;
          run.push({ node: current, pairs });
          processed.add(current);
          const sibling = current.nextElementSibling;
          let between = current.nextSibling;
          let hasText = false;
          while (between && between !== sibling) {
            if (between.nodeType === Node.TEXT_NODE && between.textContent.trim()) hasText = true;
            between = between.nextSibling;
          }
          if (hasText) break;
          current = sibling;
        }
        const all = run.flatMap(item => item.pairs);
        if (all.filter(pair => known(pair.label)).length < 2) continue;
        const leading = leadingTitle && !leadingTitle.used ? leadingTitle : null;
        const { card, body } = this.card(leading?.text || '');
        for (const pair of all) {
          const row = document.createElement('tr');
          const label = document.createElement('th');
          label.scope = 'row';
          label.textContent = pair.label;
          const value = document.createElement('td');
          value.textContent = pair.value;
          row.append(label, value);
          body.append(row);
        }
        card.dataset.rows = String(all.length);
        if (first.tagName === 'LI') {
          const item = document.createElement('li');
          item.className = 'as-list-card';
          item.append(card);
          first.before(item);
        } else first.before(card);
        run.forEach(item => item.node.remove());
        if (leading) { leading.node.remove(); leading.used = true; }
      }
    }

    enhance() {
      const source = this.querySelector('[data-as-source]');
      this.observer?.disconnect();
      try {
        if (source) {
          const leadingTitle = this.findLeadingTitle(source);
          const tables = [...source.querySelectorAll('table')].filter(table => !table.closest('.as-card') && !table.parentElement.closest('table'));
          for (const table of tables) {
            const data = tableData(table);
            if (data) this.transformTable(table, data, leadingTitle);
          }
          this.transformLines(source, leadingTitle);
          this.syncPresentation();
          this.syncCollapse();
          this.dataset.enhanced = String(source.querySelectorAll('.as-card').length);
        }
      } finally {
        if (this.isConnected) this.observer?.observe(this, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  customElements.define(tag, AutoSpecs);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
